import { render, staticRenderFns } from "./ButtonSecondary.vue?vue&type=template&id=6114d68c&scoped=true&lang=pug"
import script from "./ButtonSecondary.vue?vue&type=script&lang=ts"
export * from "./ButtonSecondary.vue?vue&type=script&lang=ts"
import style0 from "./ButtonSecondary.vue?vue&type=style&index=0&id=6114d68c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6114d68c",
  null
  
)

export default component.exports